import { NavLink } from "react-router-dom";
import {
  getInterviewQuestionsClusterPage,
  interviewClusterLearningLinks,
} from "../content/interviewQuestionsCluster";
import "../style/manualTestingCluster.css";

export default function InterviewQuestionsClusterPage({ slug }) {
  const page = getInterviewQuestionsClusterPage(slug);

  if (!page) {
    return null;
  }

  return (
    <article className="manual-cluster-page interview-cluster-page">
      <div className="manual-cluster-intro">
        <span>Interview Prep Cluster</span>
        <p>
          This Q&amp;A guide is built for {page.audience}. Open each question,
          revise the answer, then continue into the linked learning guides for
          deeper practice.
        </p>
      </div>

      {page.sections.map((section) => (
        <section className="manual-cluster-section" id={section.id} key={section.id}>
          <h2>{section.heading}</h2>
          <div className="interview-qa-list">
            {section.qas.map((item, index) => (
              <details className="interview-qa-item" key={item.question}>
                <summary>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  {item.question}
                </summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </section>
      ))}

      <section className="manual-cluster-links" aria-label="Related QA Coder learning links">
        <h2>Strengthen your answers</h2>
        <p>
          Interview answers become stronger when you connect them with real
          learning pages, examples, and hands-on practice.
        </p>
        <div>
          {interviewClusterLearningLinks.map((link) => (
            <NavLink to={link.to} key={link.to}>
              {link.label}
            </NavLink>
          ))}
        </div>
      </section>
    </article>
  );
}
